export default {
    title: "Discounts",
    description: "Benefits & discounts",
    table: {
        provider: "Provider",
        brand: "Brand",
        benefit_name: "Benefit",
        type: "Type",
        full_price: "Price (RON)",
        user_price: "User price (RON)",
        discount: {
            total: "Total",
            user_value: 'User Discount',
            platform_fee_value: 'Platform Fee Discount',
            user_price: 'User Display Price',
            platform_fee_price: 'Platform Fee Price',
            calculator: "Calculator",
        },
        actions: "Actions",

        tooltips: {
            provider: "Company providing the benefit.",
            type: "Percent/Fixed",
            brand: "Brand or product category.",
            benefit_name: "Benefit name.",
            full_price: "Product full price.",
            actions: "Edit or delete the discount.",
            discount: {
                total: "Total discount (%/RON)",
                user_value: 'User Discount (%/RON)',
                platform_fee_value: 'Platform Fee Discount (%/RON)',
                user_price: 'Price that display to user',
                platform_fee_price: 'Price platform fee',
                calculator: "Calculator",
            }
        }
    }
}